import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const ConfirmedOrdersList = () => {
  return <OrderTable status={6} action="confirmed" isActive="deliconfirm" />;
};

export default ConfirmedOrdersList;
